export enum AuthViaStorageKey {
  B2BAccepted = 'mm_b2b_accepted',
}

export type UserRole = 'member' | 'professional' | 'Group manager' | 'Group owner' | 'Group member';

export enum SubscriptionType {
  trial = 'trial',
  basic = 'basic',
  pro = 'pro',
}

export enum SubscriptionPurchasePlatform {
  WEB = 'web',
  APPLE = 'apple',
  GOOGLE = 'google',
}
